/**
 * User: Faris
 * Date: 5/24/13
 * Time: 3:24 PM
 */

require(['./config'], function(){
  require(['./libs'], function(){
    require.config({ urlArgs: 'v=' + new Date().getTime() });
    window.iws = {};
    require(['./app/view-manager', './app/flow-manager'], function(ViewManager, FlowManager) {
      window.iws.viewManager = new ViewManager();
      window.iws.flowManager = new FlowManager(FlowManager.CROSS);
      require(['./app/site'], function (Site) {
        window.iws.site = new Site();
      });
    });
  });
});
define("main", function(){});

